import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { MaskLines } from "@/components/Reveal";
import Img from "@/components/Img";

export default function PageHero({ eyebrow, title, sub, image }) {
  const { dir } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0.4]);

  return (
    <section ref={ref} data-testid="page-hero" className="relative h-[62vh] min-h-[420px] overflow-hidden flex items-end">
      <motion.div style={{ y, scale: 1.15 }} className="absolute inset-0 -z-10">
        {image && <Img src={image} width={1920} sizes="100vw" eager alt="" className="h-full w-full object-cover" />}
        <div className="absolute inset-0" style={{ background: "var(--hero-overlay)" }} />
      </motion.div>

      <motion.div style={{ opacity }} className="mx-auto w-full max-w-7xl px-5 sm:px-8 pb-16">
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="eyebrow mb-4">
          {eyebrow}
        </motion.p>
        <MaskLines lines={[title]} load className="font-head text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl" />
        {sub && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.35 }}
            className={`mt-5 max-w-2xl text-muted-foreground text-base sm:text-lg ${dir === "rtl" ? "text-right" : ""}`}
          >
            {sub}
          </motion.p>
        )}
      </motion.div>
    </section>
  );
}
